import React from "react";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import AllergenPicker from "./AllergenPicker";

/**
 * AllergenProfileCard — Settings section. Wraps the AllergenPicker in
 * the same visual frame as ToneProfileCard so the two read as a pair
 * inside the Settings page. Heading + intro localized; the picker
 * itself self-localizes via its own `t()` lookups.
 */
const AllergenProfileCard = () => {
  const { t } = useTranslation();
  return (
    <div
      className="bg-white/80 backdrop-blur-xl border border-[#EADDD7] rounded-3xl p-7 soft-shadow mb-5"
      data-testid="allergen-profile-card"
    >
      <div className="flex items-start gap-4 mb-5">
        <div className="shrink-0 h-11 w-11 rounded-full bg-[#F2E8E9] flex items-center justify-center">
          <ShieldAlert className="h-5 w-5 text-[#9B6A6C]" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-medium text-[#2C2123] leading-tight mb-1">
            {t("onboarding.steps.allergensTitle")}
          </h3>
          <p className="text-sm text-[#5C4B51] max-w-xl">
            {t("onboarding.steps.allergensSubtitle")}
          </p>
        </div>
      </div>

      <AllergenPicker mode="settings" />
    </div>
  );
};

export default AllergenProfileCard;
